/**
 * Textarea Component
 *
 * Labeled multiline text input.
 *
 * @package PresszoneComments
 */

import { el } from '../utils/dom.js';

/**
 * Render a textarea field.
 *
 * @param {string} key - State key
 * @param {string} label - Field label
 * @param {string} help - Help text below textarea
 * @param {Object} state - State object containing value
 * @param {Function} onUpdate - Callback when value changes
 * @param {number|Object} rowsOrProps - Number of rows or props object
 */
export function Textarea(key, label, help, state, onUpdate, rowsOrProps = 6) {
    const rows = typeof rowsOrProps === 'number' ? rowsOrProps : (rowsOrProps.rows || 6);
    const { styling, padding, showBorders = true, ...inputProps } = typeof rowsOrProps === 'object' ? rowsOrProps : {};

    const classes = ['presszone-comments-textarea--settings'];
    if (styling) classes.push(`presszone-comments-textarea--styling-${styling}`);
    if (padding) classes.push(`presszone-comments-textarea--padding-${padding}`);
    if (showBorders === false) classes.push('presszone-comments-textarea--no-borders');

    return el('div', { class: 'presszone-comments-form-group' },
        el('label', { class: 'presszone-comments-label--settings', for: key },
            label,
            help ? el('span', { class: 'presszone-comments-tooltip', title: help }, 'i') : null
        ),
        el('textarea', {
            id: key,
            class: classes.join(' '),
            rows: rows,
            value: state[key] || '',
            onchange: (e) => {
                state[key] = e.target.value;
                if (onUpdate) onUpdate(key, e.target.value);
            },
            ...inputProps
        }, state[key] || ''),
        help ? el('small', { class: 'presszone-comments-form-help' }, help) : null
    );
}

export default Textarea;
